import { exportStyledExcelMulti } from "./exportStyledExcel";
import {
  buildBothCurrencySections,
  type CurrencyReportBundle,
} from "./investorReportSections";

export type { CurrencyReportBundle };

/**
 * Combined investor Excel: the three finance reports for BOTH currencies in one
 * workbook — six styled sheets (Cash Flow / P&L / Balance Sheet × ETB/USD).
 * Consumes the same (rehydrated) hook outputs the on-page tables use, so the
 * figures and live balance-sheet formulas match the on-screen view.
 */
export function exportCombinedInvestorExcel(params: {
  etb: CurrencyReportBundle;
  usd: CurrencyReportBundle;
  fileName: string;
}): Promise<void> {
  return exportStyledExcelMulti(
    buildBothCurrencySections(params.etb, params.usd),
    params.fileName
  );
}
